<template>
  <v-container fluid grid-list-sm>
    <v-layout wrap>

      <v-flex d-flex xs12 sm12 md7>
        <v-layout wrap justify-space-around align-left>
          <!-- 图片新闻 -->
          <v-flex xs12 sm12>
            <v-carousel
              :value="0"
              hide-delimiters
              class="elevation-0"
              style="height: 320px">
              <v-carousel-item
                v-for="(item,i) in covers"
                :src="`/api/web/file/${item.coverId}`"
                :key="i"
                reverse-transition="fade"
                transition="fade"
                style="cursor: pointer;"
                @click="$router.push(`/tabloid/${item.dbid}`)"
              >
                <!--:to="`/tabloid/${item.dbid}`"-->
                <!--:reverse-transition="randomTransition()"-->
                <!--:href="`/tabloid/${item.dbid}`"-->
                <!--:transition="randomTransition()"-->
                <!--:reverse-transition="randomTransition()"-->
                <div
                  class="subheading px-2 pb-3"
                  style="position: absolute; bottom: 0; color: white;">
                  <router-link style="color: white;" :to="`/tabloid/${item.dbid}`" target="_blank" v-html="item.title"/>
                </div>
              </v-carousel-item>
            </v-carousel>
          </v-flex>

          <!-- 科研管理信息系统 -->
          <v-flex xs12 sm4 md4>
            <v-btn
              large
              depressed
              color="info"
              block
              href="/system.html#/login" target="_blank">
              <v-icon large>widgets</v-icon>
              <span class="subheading">科研管理信息系统</span>
            </v-btn>
          </v-flex>

          <!-- 办事指南 -->
          <v-flex xs12 sm4 md4>
            <v-btn
              large
              depressed
              color="success"
              block
              to="/guide">
              <v-icon large>map</v-icon>
              <span class="subheading">办事指南</span>
            </v-btn>
          </v-flex>

          <!-- 下载专区 -->
          <v-flex xs12 sm4 md4>
            <v-btn
              large
              depressed
              color="warning"
              block
              to="/download">
              <v-icon large>cloud_download</v-icon>
              <span class="subheading">下载专区</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- 通知公告 -->
      <v-flex
        d-flex xs12 sm12 md5
        v-if="sections['notice']"
      >
        <v-card tile flat class="sec-card">
          <v-toolbar dense flat>
            <v-btn icon class="hidden-xs-only">
              <v-icon color="blue">{{ sections['notice'].section.icon || 'apps' }}</v-icon>
            </v-btn>
            <v-toolbar-title class="mx-0 px-0 subheading v-subheader">
              {{ sections['notice'].section.name }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="$router.push('/notice')">
              <v-icon>more_horiz</v-icon>
            </v-btn>
          </v-toolbar>
          <v-divider color="blue"/>
          <v-card-text>
            <ul class="section-list notice">
              <li v-for="a in sections['notice'].articles.slice(0,9)" :key="a.dbid">
                <router-link :to="`/article/${a.dbid}`" target="_blank" v-html="a.title"/>
                <span v-html="a.pubDate"></span>
              </li>
            </ul>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- 学术活动预告 -->
      <v-flex d-flex xs12 sm12 md7 v-if="sections['report']">
        <v-card tile flat>
          <v-toolbar dense flat>
            <v-btn icon class="hidden-xs-only">
              <v-icon color="green">{{ sections['report'].section.icon || 'apps' }}</v-icon>
            </v-btn>
            <v-toolbar-title class="mx-0 px-0 subheading v-subheader">
              {{ sections['report'].section.name }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="$router.push('/report')">
              <v-icon>more_horiz</v-icon>
            </v-btn>
          </v-toolbar>
          <v-divider color="green"/>
          <v-card-text>
            <v-layout row wrap v-if="sections['report'].articles">
              <v-flex d-flex
                      v-for="(a, i) in sections['report'].articles.slice(0,2)"
                      :key="a.dbid"
                      xs12 sm12 md6>
                <div class="px-2" :style="{borderLeft: `${i > 0 ? 1 : 0}px solid lightgray`}">
                  <div style="min-height: 48px;">
                    <a :href="`/#/article/${a.dbid}`"
                       target="_blank"
                       class="x-title">
                      {{ a.title }}
                    </a>
                  </div>
                  <p class="x-title">
                    {{ a.dateTime.substring(0, 10) }} {{ a.dateTime.substring(11, 16) }}
                  </p>
                  <p>
                    <span class="subheader">报告人：</span>{{ a.speaker }}
                  </p>
                  <p>
                    <span class="subheader">活动地点：</span>{{ a.venue }}
                  </p>
                  <p>
                    <span class="subheader">主办单位：</span> {{ a.organizer }}
                  </p>
                </div>
              </v-flex>

            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- 新闻动态 -->
      <!--
      <v-flex d-flex xs12 sm12 md5 v-if="sections['news']">
        <v-card tile flat>
          <v-toolbar dense flat>
            <v-btn icon class="hidden-xs-only">
              <v-icon color="green">{{sections['news'].section.icon || 'apps'}}</v-icon>
            </v-btn>
            <v-toolbar-title class="mx-0 px-0 subheading v-subheader">
              {{sections['news'].section.name}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="$router.push('/news')">
              <v-icon>more_horiz</v-icon>
            </v-btn>
          </v-toolbar>
          <v-divider color="green"/>
          <v-card-text>
            <ul class="section-list news">
              <li v-for="a in sections['news'].articles.slice(0,9)" :key="a.dbid">
                <router-link :to="`/article/${a.dbid}`" target="_blank" v-html="a.title"/>
                <span v-html="a.pubDate"></span>
              </li>
            </ul>
          </v-card-text>
        </v-card>
      </v-flex>
      -->

      <v-flex d-flex xs12 sm12 md5 v-if="sections['news']" style="width: 100% !important;">
        <v-card tile flat class="sec-card">
          <v-toolbar dense flat>
            <v-btn icon class="hidden-xs-only">
              <v-icon color="green">{{ sections['news'].section.icon || 'apps' }}</v-icon>
            </v-btn>
            <v-toolbar-title class="mx-0 px-0 subheading v-subheader">
              {{ sections['news'].section.name }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="$router.push('/news')">
              <v-icon>more_horiz</v-icon>
            </v-btn>
          </v-toolbar>
          <v-divider color="green"/>
          <v-card-text>
            <ul class="section-list news">
              <li v-for="a in newsArticles.slice(0,9)" :key="a.dbid">
                <router-link :to="`/article/${a.dbid}`" target="_blank" v-html="a.title"/>
                <span v-html="a.pubDate"></span>
              </li>
            </ul>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-card tile flat>
          <v-toolbar dense flat>
            <v-btn icon class="hidden-xs-only">
              <v-icon color="orange">link</v-icon>
            </v-btn>
            <v-toolbar-title class="mx-0 px-0 subheading v-subheader">
              友情链接
            </v-toolbar-title>
          </v-toolbar>
          <v-divider color="orange"/>
          <v-card-text>
            <v-btn depressed v-for="(a, i) in links" :href="a.href" :key="i" target="_blank">
              {{ a.name }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'Index',
  data() {
    return {
      sections: {},

      transitions: [
        'fade-transition', 'fade-reverse-transition',
        'tab-transition', 'tab-reverse-transition',
        'bottom-sheet-transition', 'top-sheet-transition',
        'slide-x-transition', 'slide-x-reverse-transition',
      ],

      links: [{
        name: '中华人民共和国科学技术部',
        href: 'http://www.most.gov.cn'
      }, {
        name: '国家自然科学基金委员会',
        href: 'http://www.nsfc.gov.cn/'
      }, {
        name: '云南省科学技术厅',
        href: 'http://kjt.yn.gov.cn'
      }, {
        name: '中华人民共和国教育部',
        href: 'http://www.moe.gov.cn'
      }, {
        name: '教育部科学技术司',
        href: 'http://www.moe.gov.cn/s78/A16/'
      }
        // , {
        //     name: '教育部科技发展中心',
        //     href: 'http://www.cutech.edu.cn/cn/index.htm'
        // }
      ]
    }
  },
  computed: {
    covers() {
      return this.sections.tabloid ? (
        this.sections.tabloid.articles
          .filter(a => a.coverId !== undefined)
          .slice(0, 5)
      ) : [];
    },

    newsArticles() {
      return this.sections["news"].articles.concat(this.sections["tabloid"].articles)
        .sort((a, b) => (a.pubDate < b.pubDate) ? 1 : (a.pubDate > b.pubDate) ? -1 : 0)
    }
  },

  methods: {
    randomTransition() {
      const idx = Math.floor(Math.random() * this.transitions.length);
      return this.transitions[idx];
    }
  },

  beforeRouteEnter(to, from, next) {
    const indexUrl = '/api/site/index';

    Vue.axios.get(indexUrl).then(
      rsp =>
        next(vm => vm.sections = rsp.data)
    )
  },
  // 路由改变前，组件就已经渲染完了
  // 逻辑稍稍不同
  beforeRouteUpdate() {
    const indexUrl = '/api/site/index';
    Vue.axios.get(indexUrl).then(rsp => this.sections = rsp.data)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div.card__text {
  padding: 5px 20px;
}

ol, ul {
  list-style: none;
}

li {
  display: flex;
  flex-direction: row;
  text-align: -webkit-match-parent;
  margin-bottom: .333em;
  border-bottom: 1px dashed lightgray;
  height: 1.75em;
}

li:last-child {
  border-bottom: none;
}

li > a {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
  color: #333333;
}

li > a:visited {
  color: #333333;
}

li > a:hover {
  color: #1976d2;
}

li > span {
  width: 6em;
  text-align: right;
}

/* 对 Edge 无效*/
/*ul.section-list > li:before {*/
/*font-family: 'Material Icons',monospace;*/
/*!*content: "■";*!*/
/*content: "stop";*/
/*font-size: 9pt;*/
/*color: lightgrey;*/
/*}*/

ul.notice > li:before {
  color: lightblue;
}

ul.news > li:before {
  color: lightgreen;
}

img.jumbotron__image {
  height: 400px !important;
  width: auto;
}

a {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
  color: #333333;
}

a:visited {
  color: #333333;
}

a:hover {
  color: #1976d2;
}

a.x-title, p.x-title {
  font-size: 14px;
  font-weight: 500;
  text-align: center !important;
  white-space: normal;
  text-indent: 0;
  display: block;
}

.sec-card {
  width: 100% !important;
}
</style>
